import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import { TbReload } from "react-icons/tb";
import Spinner from "../../Components/Spinner";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenCustom = ({
    account_id,
    context_id,
    org_id,
    selectedSource,
    show,
    handleClose,
    setOpenTestModal
}) => {
    const { t } = useLanguage()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const fetchData = async () => {
        if (!show) return;
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_custom_source`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    context_id,
                    context_source_id: selectedSource?.id
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setData(result.page || []);
        } catch (err) {
            console.error("Error fetching models:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        fetchData();
    }, [show]);

    const closeModal = () => {
        handleClose();
        setLoading(false)
        setErrorMessage({ message: "", display: false });
        setData([])
        setOpenTestModal(true)
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {loading ? (
                        <div className="open_frame_title_loading fade-in"></div>
                    ) : (
                        <div className="fade-in">
                            {data?.title}
                        </div>
                    )}
                </p>
                <button className="context_window_footer_btn" onClick={fetchData}>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <TbReload />
                    )}
                </button>
            </div>
            <div className="modal_main_cont">
                {loading ? (
                    <div className="loading_logs_cont fade-in">
                        <p>{t.context.loading_content}</p>
                    </div>
                ) : data.length == 0 ? (
                    <div className="organizations_cont_no_items_mex fade-in">
                        <p>{t.no_data_found}</p>
                    </div>
                ) : (
                    <div className="custom_text_wrapper">
                        <div className="custom_text" dangerouslySetInnerHTML={{ __html: data.text }}></div>
                    </div>
                )}
            </div>
            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                    >
                        <i className="fa-solid fa-chevron-left"></i> {t.back}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default OpenCustom;